import React, { Component } from 'react';
import { StickyContainer, Sticky } from 'react-sticky';

import Canvas from './Canvas/';
import Properties from './Properties/';
import QuestionLibrary from './Questions';

const CURRENT_STEP = 'QUESTION_BUILDER';

class QuestionBuilder extends Component {
  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    return <StickyContainer className="row">
      <div className="col-lg-3">
        <Sticky>
          {({ style }) => (
            <div style={style}>
              <Properties />
            </div>
          )}
        </Sticky>
      </div>

      <div className="col-lg-5">
        <Canvas />
      </div>

      <div className="col-lg-4">
        <Sticky>
          {({ style }) => (
            <div style={style}>
              <QuestionLibrary />
            </div>
          )}
        </Sticky>
      </div>
    </StickyContainer>
  }
}


export default QuestionBuilder;